import { render } from "./access-denied.vue?vue&type=template&id=bb1b90bc"
import script from "./access-denied.vue?vue&type=script&lang=js"
export * from "./access-denied.vue?vue&type=script&lang=js"

import exportComponent from "D:\\MY PROJECTS\\Vue 3 Project\\MarriageBeauroAdmin\\marriage_beauro_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__